import UsersPage from "../pages/Users/Users";
import UserPage from "../containers/User/User";
import AddUsersPage from "../containers/AddUsers/AddUsersPage";
import Wallet from "../pages/Wallet/Wallet";
import EmployeeAssignCover from "../pages/UserDetails/EmployeeAssignCover/EmployeeAssignCover";
import UserPayments from "../pages/Payments/Payments";
import PolicyIssuedByUser from "../pages/UserDetails/PolicyIssuedByUser/PolicyIssuedByUser";
import TripDetails from "../../issuance/containers/TripTravellerDetail/TripDetails";

// Common Routes (always mapped directly for all users)
const commonRoutes = [
  { path: "user-profile", element: <UserPage mode={"edit"} /> },
  { path: "wallet", element: <Wallet /> },
  { path: "assign-covers", element: <EmployeeAssignCover /> },
  { path: "payments", element: <UserPayments /> },
  { path: "policies-issued", element: <PolicyIssuedByUser /> },
  { path: "policies-issued/:id", element: <TripDetails /> },
];

// Helper to prefix paths with 'user/users/'
const withLayout = (children) => {
  return children.map((route) => ({
    ...route,
    path: `user/user-details/${route.path}`,
  }));
};

// Main user routes
const UserDetailRoutes = [
  { path: "user/user-details", element: <UsersPage /> },
  { path: "user/users/create", element: <AddUsersPage /> },
  ...withLayout(commonRoutes),
];

export default UserDetailRoutes;